module.exports = __webpack_public_path__ + "img/aidtools_s2.46eaab8d.png";